import { render, staticRenderFns } from "./CustomerServiceV2.vue?vue&type=template&id=0d3a8c5f&scoped=true"
import script from "./CustomerServiceV2.vue?vue&type=script&lang=js"
export * from "./CustomerServiceV2.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceV2.vue?vue&type=style&index=0&id=0d3a8c5f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a8c5f",
  null
  
)

export default component.exports